import React from 'react';

const STATUS_CONFIG = {
  Draft: { bg: 'bg-muted', text: 'text-muted-foreground', dot: 'bg-muted-foreground' },
  Submitted: { bg: 'bg-[rgba(59,76,76,0.07)]', text: 'text-blue-700', dot: 'bg-[rgba(59,76,76,0.07)]0' },
  Reviewed: { bg: 'bg-success/10', text: 'text-success', dot: 'bg-success' },
  Closed: { bg: 'bg-foreground/5', text: 'text-foreground', dot: 'bg-foreground/40' },
};

export default function ReviewStatusBadge({ status, size = 'sm' }) {
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.Draft;
  const textSize = size === 'xs' ? 'text-xs' : 'text-xs';
  const px = size === 'xs' ? 'px-1.5 py-0.5' : 'px-2 py-0.5';
  return (
    <span className={`inline-flex items-center gap-1.5 ${px} rounded-full font-caption font-medium ${textSize} ${config?.bg} ${config?.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config?.dot}`} />
      {status}
    </span>
  );
}
